'use strict';

const jQuery = require('jquery');

const mediator = require('./../../../core/mediator');

const focusClass = 'btn-focus';

const unFocus = function() {
    jQuery('.cloud-toolbar-main').find('.btn.' + focusClass).removeClass(focusClass);
};

const setFocus = function(element) {
    unFocus();
    element.find('.btn').addClass(focusClass);
};

const checkSize = function() {
    jQuery('body')[jQuery(window).height() < 680 ? 'addClass' : 'removeClass']('small-screen');
};

const resize = function() {
    jQuery(window).resize(checkSize);
};

const init = function() {
    checkSize();
    resize();
};

const publish = function(html, item, data) {
    html.on('click', function() {
        let current = jQuery(this);
        let params = {
                'target': current,
                'params': data || {},
            };

        if (current.find('.btn').hasClass('btn-focus')) {
            unFocus();
            mediator.publish('menu:close');
        } else {
            setFocus(current);

            mediator.publish(item.eventName, params);
        }

        return false;
    });

    if (true === item.focus) {
        setFocus(html);
    }
};

module.exports.init = init;
module.exports.publish = publish;
module.exports.unFocus = unFocus;
